{
  "general": {
    "article": "Colorway",
    "articles": "Colorways",
    "model": "Product",
    "models": "Products"
  }
}
